<template>

    <section class="article-accordion">

        <h2
                class="list-headline"
                v-if="articleAccordionData['content_list_headline']"
                v-on:click="openPopup()"
        >
            {{ articleAccordionData['content_list_headline'] }}
        </h2>

        <template v-for="(listItem, listItemIndex) in articleAccordionData['content_list_repeater']">
            <template v-for="(listContent, listContentIndex) in listItem['list_content_composer']">
                <h2
                        :data-accordion-list-item-index="listItemIndex"
                        :data-accordion-list-content-index="listContentIndex"
                        class="list-content-subline"
                        v-if="listContent['acf_fc_layout'] === 'list_content_composer_subline_h2'"
                        v-on:click="openPopup()"
                >
                    {{ listContent['list_content_subline_h2'] }}
                </h2>
                <h3
                        class="list-content-subline"
                        v-if="listContent['acf_fc_layout'] === 'list_content_composer_subline_h3'"
                >
                    {{ listContent['list_content_subline_h3'] }}
                </h3>
                <div
                        class="list-content-copy-body"
                        v-html="listContent['list_content_copy_body']"
                        v-if="listContent['acf_fc_layout'] === 'list_content_composer_copy_body'"
                ></div>
                <div
                        class="list-content-image-container"
                        v-if="listContent['acf_fc_layout'] === 'list_content_composer_image' && listContent['list_content_image_1440_1080']"
                >
                  <div
                      class="list-content-image">
                    <img
                            v-bind:alt="listContent['list_content_image_alt_text']"
                            v-bind:src="listContent['list_content_image_1440_1080']"
                    >
                  </div>
                  <div class="list-content-image-copyright-text"
                         v-if="listContent['list_content_image_copyright_text']"
                         v-html="'&copy; ' + listContent['list_content_image_copyright_text']"></div>
                </div>
            </template>
        </template>

    </section>

</template>

<script>

    // console.log('ArticleAccordion');

    import cssMediaQueryHelper from '../services/cssMediaQueryHelper';
    import cssUnitHelper from '../services/cssUnitHelper';

    export default {
        created(){
            this.$root.events.$on('popupAccordionSelect', (id, listItemIndex, listContentIndex)=>{
                if (id === this.articleAccordionId) {
                    const scrollPosition = $('[data-accordion-list-item-index="' + listItemIndex + '"][data-accordion-list-content-index="' + listContentIndex + '"]').offset().top - cssUnitHelper.remToPx(4.5) * cssMediaQueryHelper.watch.factor;
                    window.scrollTo(0, scrollPosition);
                }
            });
        },
        destroyed(){
        },
        mounted(){
        },
        components : {},
        computed : {},
        data(){
            return {
                listData : {},
            };
        },
        props : {
            'articleAccordionData' : {
                default : {},
                type : Object,
            },
            'articleAccordionId' : {
                default : '',
                type : String,
            },
        },
        methods : {
            openPopup(){
                this.$root.states.popupAccordionData = this.articleAccordionData;
                this.$root.states.popupAccordionId = this.articleAccordionId;
            },
        },
    }

</script>

<style lang="scss">

    @import '../../css/variables';

    .article-accordion {
        .list-headline {
            position: relative;
            margin: 4rem 0;
            color: $color-nochvielvor-pink;
            font-size: 1.5rem;
            font-weight: bold;
            cursor: pointer;
            overflow: visible;
            @media screen and (max-width: 767px) {
                font-size: 1.5rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                margin: 2rem 0 1rem * $factor-1200;
                font-size: 1.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 2rem 0 1rem * $factor-1440;
                font-size: 1.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 2rem 0 1rem * $factor-1920;
                font-size: 1.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 2rem 0 1rem * $factor-2400;
                font-size: 1.5rem * $factor-2400;
            }
            &:before {
                content: '';
                position: absolute;
                left: -1.6875rem - 1rem;
                top: 0;
                width: 1.6875rem;
                height: 100%;
                background-image: url(/img/ic_accordion_e73e51.svg);
                background-position: 0 50%;
                background-repeat: no-repeat;
                background-size: 1.6875rem 1.5625rem;
                @media screen and (max-width: 767px) {
                    display: none;
                }
                @media screen and (min-width: 1200px) {
                    left: (-1.6875rem - 1rem) * $factor-1200;
                    width: 1.6875rem * $factor-1200;
                    background-size: 1.6875rem * $factor-1200 1.5625rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    left: (-1.6875rem - 1rem) * $factor-1440;
                    width: 1.6875rem * $factor-1440;
                    background-size: 1.6875rem * $factor-1440 1.5625rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    left: (-1.6875rem - 1rem) * $factor-1920;
                    width: 1.6875rem * $factor-1920;
                    background-size: 1.6875rem * $factor-1920 1.5625rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    left: (-1.6875rem - 1rem) * $factor-2400;
                    width: 1.6875rem * $factor-2400;
                    background-size: 1.6875rem * $factor-2400 1.5625rem * $factor-2400;
                }
            }
        }
        h2.list-content-subline {
            position: relative;
            margin: 1.5rem 0;
            font-size: 1.5rem;
            font-weight: bold;
            cursor: pointer;
            overflow: visible;
            @media screen and (max-width: 767px) {
                padding-left: (1.6875rem + 1rem) * $factor-720;
                font-size: 1.5rem * $factor-720;
            }
            @media screen and (min-width: 768px) {
                font-size: 30px;
            }
            /*@media screen and (min-width: 1200px) {
                margin: 1.5rem * $factor-1200 0;
                font-size: 1.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 1.5rem * $factor-1440 0;
                font-size: 1.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 1.5rem * $factor-1920 0;
                font-size: 1.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 1.5rem * $factor-2400 0;
                font-size: 1.5rem * $factor-2400;
            }*/
            &:last-child {
                margin-bottom: 0;
            }
            &:before {
                content: '';
                position: absolute;
                left: -1.6875rem - 1rem;
                top: 0;
                width: 1.6875rem;
                height: 100%;
                background-image: url(/img/ic_accordion_000000.svg);
                background-position: 0 50%;
                background-repeat: no-repeat;
                background-size: 1.6875rem 1.5625rem;
                @media screen and (max-width: 767px) {
                    left: 0;
                    background-size: 1.6875rem * $factor-720 1.5625rem * $factor-720;
                }
                @media screen and (min-width: 1200px) {
                    left: (-1.6875rem - 1rem) * $factor-1200;
                    width: 1.6875rem * $factor-1200;
                    background-size: 1.6875rem * $factor-1200 1.5625rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    left: (-1.6875rem - 1rem) * $factor-1440;
                    width: 1.6875rem * $factor-1440;
                    background-size: 1.6875rem * $factor-1440 1.5625rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    left: (-1.6875rem - 1rem) * $factor-1920;
                    width: 1.6875rem * $factor-1920;
                    background-size: 1.6875rem * $factor-1920 1.5625rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    left: (-1.6875rem - 1rem) * $factor-2400;
                    width: 1.6875rem * $factor-2400;
                    background-size: 1.6875rem * $factor-2400 1.5625rem * $factor-2400;
                }
            }
        }
        h3.list-content-subline {
            margin: 0;
            //font-size: 1.25rem;
            font-size: 1rem;
            font-weight: bold;
            @media screen and (max-width: 767px) {
                //font-size: 1.25rem * $factor-720;
                font-size: 1rem * $factor-720;
            }
            @media screen and (min-width: 1200px) {
                //font-size: 1.25rem * $factor-1200;
                font-size: 1rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                //font-size: 1.25rem * $factor-1440;
                font-size: 1rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                //font-size: 1.25rem * $factor-1920;
                font-size: 1rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                //font-size: 1.25rem * $factor-2400;
                font-size: 1rem * $factor-2400;
            }
        }
        .list-content-copy-body {
            margin: 0 0 1rem 0;
            font-size: 1rem;
            line-height: 1.6;
            @media screen and (max-width: 767px) {
                margin: 0 0 1rem * $factor-720 0;
                font-size: 1rem * $factor-720;
            }
            @media screen and (min-width: 768px) {
                font-size: 18px;
            }
            /*@media screen and (min-width: 1200px) {
                margin: 0 0 1rem * $factor-1200 0;
                font-size: 1rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
                margin: 0 0 1rem * $factor-1440 0;
                font-size: 1rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
                margin: 0 0 1rem * $factor-1920 0;
                font-size: 1rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
                margin: 0 0 1rem * $factor-2400 0;
                font-size: 1rem * $factor-2400;
            }*/
            &:last-child {
                margin-bottom: 0;
            }
            a {
                position: relative;
                padding-left: 1em;
                display: inline-block;
                color: $color-nochvielvor-pink;
                // word-break: break-all;
                &:before {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 1em;
                    height: 100%;
                    background-image: url(/img/ic_chevron_inline_right_e73e51.svg);
                    background-position: 0 50%;
                    background-repeat: no-repeat;
                    background-size: 0.8em 0.8em;
                }
            }
            ol, ul {
                position: relative;
                margin: 0 0 1rem 0;
                padding: 0;
                list-style-type: none;
                @media screen and (max-width: 767px) {
                    margin: 0 0 1rem * $factor-720 0;
                }
                @media screen and (min-width: 1200px) {
                    margin: 0 0 1rem * $factor-1200 0;
                }
                @media screen and (min-width: 1440px) {
                    margin: 0 0 1rem * $factor-1440 0;
                }
                @media screen and (min-width: 1920px) {
                    margin: 0 0 1rem * $factor-1920 0;
                }
                @media screen and (min-width: 2400px) {
                    margin: 0 0 1rem * $factor-2400 0;
                }
            }
            li {
                margin-left: 1.5em;
                padding: 0;
            }
            ol {
                counter-reset: list-counter;
                > li {
                    counter-increment: list-counter;
                    &:before {
                        content: counter(list-counter) '.';
                        position: absolute;
                        left: 0;
                    }
                }
            }
            ul {
                margin-left: 0.75em;
                > li {
                    &:before {
                        content: '';
                        position: absolute;
                        left: 0;
                        width: 0.5em;
                        height: 0.5em;
                        margin-top: 1ex;
                        background: $color-nochvielvor-pink;
                        transform: rotate(-45deg);
                    }
                }
            }
            p {
                margin: 0 0 1rem 0;
                @media screen and (min-width: 1200px) {
                    margin: 0 0 1rem * $factor-1200 0;
                }
                @media screen and (min-width: 1440px) {
                    margin: 0 0 1rem * $factor-1440 0;
                }
                @media screen and (min-width: 1920px) {
                    margin: 0 0 1rem * $factor-1920 0;
                }
                @media screen and (min-width: 2400px) {
                    margin: 0 0 1rem * $factor-2400 0;
                }
                &:last-child {
                    margin-bottom: 0;
                }
            }
        }
        .list-content-image-container {
            @media screen and (max-width: 768px) {
              margin: 4rem * $factor-720 -1.5rem;
            }
            @media screen and (min-width: 1200px) {
              margin: 4rem * $factor-1200 -7.5rem * $factor-1200;
            }
            @media screen and (min-width: 1440px) {
              margin: 4rem * $factor-1440 -7.5rem * $factor-1440;
            }
            @media screen and (min-width: 1920px) {
              margin: 4rem * $factor-1920 -7.5rem * $factor-1920;
            }
            @media screen and (min-width: 2400px) {
              margin: 4rem * $factor-2400 -7.5rem * $factor-2400;
            }
            &:last-child {
                margin-bottom: 0;
            }
            .list-content-image {
                font-size: 1rem;
                @media (min-width: 768px) {
                    position: relative;
                    height: 24rem;
                    overflow: hidden;
                }
                @media screen and (min-width: 1200px) {
                    height: 24rem * $factor-1200;
                }
                @media screen and (min-width: 1440px) {
                    height: 24rem * $factor-1440;
                }
                @media screen and (min-width: 1920px) {
                    height: 24rem * $factor-1920;
                }
                @media screen and (min-width: 2400px) {
                    height: 24rem * $factor-2400;
                }
                img {
                    width: 100%;
                    height: auto;
                    @media (min-width: 768px) {
                        position: absolute;
                        left: 0;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
            }
            .list-content-image-copyright-text {
                opacity: 0.4;
                font-size: 10px;
                text-align: right;
                margin: 15px auto 0;
                padding-left: 15px;
                padding-right: 15px;
                -moz-user-select: none;
                -webkit-user-select: none;
                -ms-user-select: none;
                -o-user-select: none;
                user-select: none;
                @media (min-width: 768px) {
                    font-size: 12px;
                }
            }
        }
    }

</style>
